import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import PageTitle from "../components/common/PageTitle";
import ClientLogoUpload from "../components/project/ClientLogoUpload";
import { JWT } from "../config/constants";
import { showError } from "../utils/toast";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../config/constants";

export default function Logo() {
  const navigate = useNavigate();
  const [projectId, setProjectId] = useState(null);
  const [projectName, setProjectName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get project_id from JWT token
    const token = localStorage.getItem(JWT.TOKEN_KEY);
    if (!token) {
      showError("Anda harus login terlebih dahulu");
      setLoading(false);
      return;
    }

    try {
      const decoded = jwtDecode(token);
      const userProjectId =
        decoded.project_id || localStorage.getItem(JWT.PROJECT_ID_KEY);
      const userProjectName =
        localStorage.getItem(JWT.PROJECT_NAME_KEY) || "Project Anda";
      setProjectId(userProjectId);
      setProjectName(userProjectName);
    } catch (err) {
      showError("Login terlebih dahulu");
      navigate(ROUTES.LOGIN);
    } finally {
      setLoading(false);
    }
  }, []);

  const renderContent = () => {
    if (loading) {
      return (
        <div className="flex justify-center items-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      );
    }

    if (!projectId) {
      return (
        <div className="bg-yellow-50 border mt-4 border-yellow-200 rounded-lg p-6 text-center">
          <p className="text-yellow-800">
            Anda belum memiliki project yang terdaftar. Silakan hubungi admin
            untuk mendapatkan akses project.
          </p>
        </div>
      );
    }

    return (
      <>
        <p className="text-gray-600 mt-2 mb-6">
          Kelola logo client untuk project:{" "}
          <span className="font-semibold text-gray-800">{projectName}</span>
        </p>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Upload Logo Client
              </h3>
              <p className="text-sm text-gray-600">
                Logo ini akan digunakan pada header Excel export Lessons Learned
                untuk project Anda.
              </p>
            </div>

            <ClientLogoUpload projectId={projectId} />

            <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <h4 className="font-medium text-blue-900 mb-3">Informasi Logo:</h4>
              <ul className="text-sm text-blue-800 space-y-2">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Format file yang didukung: PNG atau JPEG</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Ukuran file maksimal: 2MB</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>
                    Rekomendasi rasio logo: 2:1 (landscape) untuk hasil terbaik
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>
                    Logo akan otomatis muncul di header Excel saat Anda melakukan
                    export lessons learned
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>
                    Anda dapat mengganti logo kapan saja dengan mengupload logo
                    baru
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="p-6 pt-20">
      <PageTitle>Logo Project</PageTitle>
      {renderContent()}
    </div>
  );
}
